import React from "react";
import { getAppOrderFields, getAppOrderStatusBadgeClass } from "../utils";
import { getTranslatedAppOrderStatus } from "../../../../translates/sales/sales";
import { AppOrderField, AppOrderInfoProps } from "../interfaces";

export const AppOrderInfo: React.FC<AppOrderInfoProps> = ({ appOrder }) => {
  const fields: AppOrderField[] = getAppOrderFields(appOrder);

  return (
    <div className="space-y-3">
      <h2 className="text-lg font-medium text-gray-800">Pedido BM</h2>
      <div className="overflow-hidden rounded-xl border border-gray-200 bg-white p-4">
        <div className="grid grid-cols-2 gap-6 lg:grid-cols-4">
          <div>
            <div className="mb-1 text-sm text-gray-500">Cliente</div>
            <div className="text-sm font-medium">
              {appOrder.customer_name || "-"}
            </div>
            <div className="text-sm text-gray-500">
              {appOrder.customer_phone_number || "-"}
            </div>
          </div>
          <div>
            <div className="mb-1 text-sm text-gray-500">Estado</div>
            {/* Height matches the plain values beside it, and the negative margin cancels the
                pill's padding so its text starts on the same edge as every other value */}
            <span
              className={`-ml-2.5 inline-flex h-5 items-center rounded-full px-2.5 text-xs font-medium ${getAppOrderStatusBadgeClass(
                appOrder.status,
              )}`}
            >
              {getTranslatedAppOrderStatus(appOrder.status)}
            </span>
          </div>
          {fields.map((field) => (
            <div key={field.label}>
              <div className="mb-1 text-sm text-gray-500">{field.label}</div>
              <div className="text-sm font-medium">{field.value}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
